module.exports = __webpack_public_path__ + "img/subtract-white.2c068977.svg";